import React, { useState, useEffect } from 'react';
import Modal from "react-bootstrap/Modal";
import { useHistory } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';

import {
  ModalContent,
  Card,
  TextQuantity,
  ButtonOutline
} from './styles';
import { InfoButton } from '~/components/layout/Buttons';

const OtherPayment = ({ modal,  setModal, loadingConfirmOther, setLoadingConfirmOther }) => {
  const history = useHistory();
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setModal(modalOpen);
  }, [modalOpen]);

  useEffect(() => {
    setModalOpen(modal);
  }, [modal]);

  function handleModal() {
    setModal(!modal);
    setLoadingConfirmOther(!loadingConfirmOther)
  }

  function handle() {
    history.push('/pagamento-a-vista');
  }

  return (
    <Modal
      show={modalOpen}
      onHide={() => {
        handleModal()
      }}
      centered={true}
    >
      <Modal.Body>
        <ModalContent>
          <>
            <Card>
              <Row>
                <Col>
                  <TextQuantity style={{ color: '#000FFF', marginBottom: '0.5rem' }}>Alterar forma de pagamento</TextQuantity>
                </Col>
              </Row>
            </Card>
            <Row>
              <Col>
                <TextQuantity style={{ marginBottom: '1rem', marginTop: '0.5rem' }} >
                  O pagamento via PIX é reconhecido imediatamente após o pagamento.
                  Outras formas de pagamento podem demorar a serem compensadas , gerando atrasos no abastecimento programado.
                </TextQuantity>
                <TextQuantity style={{ marginBottom: '1rem', marginTop: '1rem' }} >
                  Deseja Continuar?
                </TextQuantity>
              </Col>
            </Row>
            <Row>
                <Col>
                  <InfoButton onClick={() => handleModal()} style={{ marginTop: '0.5rem' }} >
                    <div>Não</div>
                  </InfoButton>
                </Col>
                <Col>
                  < ButtonOutline outline onClick={() => handle()} style={{ marginTop: '0.5rem' }}>
                    <div>Sim</div>
                  </ButtonOutline>
                </Col>
              </Row>
          </>
        </ModalContent>
      </Modal.Body>
    </Modal>
  );
};

export default OtherPayment;
